module.exports = __webpack_public_path__ + "media/images/flags/1x1/tza-09c9b71718a90c5e637406ff0184a441.svg";